<template>
  <div>
    <my-clients-list
      :items="elements"
      :loading="loading"
      :count="count"
      :search="search"
      :can-add-clients="canAddCustomers"
      :tabs="tabs"
      @tabChanged="onTabChange"
      @cellClicked="onCellClicked"
      @onSearch="onSearch"
      @reload="reload"
      @load-more="onLoadMore"
      @addClient="onAddClient"
    />
  </div>
</template>
<script>

import Listable from '@/components/mixins/listable';
import { EventBus } from '@/event-bus';
import utilsMixin from '@/_utilities/utilsMixin';
import MyClientsList from './MyClientsList';

export default {
  name: 'MyClientsListContainer',
  components: {
    MyClientsList,
  },
  mixins: [Listable, utilsMixin],
  props: {
    source: {
      type: String,
      default: 'customers',
    },
    pageSize: {
      type: Number,
      default: 50,
    },
    mode: {
      type: String,
      default: 'loadMore',
    },
  },
  computed: {
    permissionViewsAllClient() {
      return this.usePermission('view_all_clients') || this.useFeature('edits_sendable_to_all_institution_clients');
    },
    canAddCustomers() {
      return this.useFeature('add_customers');
    },
    count() {
      return this.$store.state.customers.count;
    },
    isAdminMode() {
      return this.$store.state.account.isAdminMode;
    },
    tabs() {
      if (this.isAdminMode) {
        return [];
      }
      if (this.permissionViewsAllClient) {
        return ['My Clients', 'All Clients', 'Groups'];
      }
      return ['My Clients', 'Groups'];
      // return ['My Clients', 'All Clients', 'Groups'];
    },
  },
  methods: {
    onTabChange(evt) {
      if (this.permissionViewsAllClient) {
        if (evt === 1) {
          this.$router.push('/clients/all');
        } else if (evt === 2) {
          this.$router.push('/clients/groups');
        } else {
          // TODO for My Clients
          this.$router.push('/clients/my');
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (evt === 0) {
          this.$router.push('/clients/my');
        } else {
          this.$router.push('/clients/groups');
        }
      }
    },
    onCellClicked(evt) {
      this.$router.push(`/clients/${evt.pk}`);
    },
    onSearch(term) {
      this.search = term;
    },
    onLoadMore() {
      this.loadMore();
    },
    onAddClient() {
      EventBus.$emit('open-add-client-modal');
    },
  },
};
</script>
